// extracted by mini-css-extract-plugin
export default {"navbar-content":"AppLayout_navbar-content__Z3PWv","user-avatar":"AppLayout_user-avatar__6Qwal"};